<template>
	<aside id="basic">
		<div class="results">
			<div class="content">
				<template v-if="searchResults">
					<provider v-for="(item, index) in searchResults.data" 
                    :key="index" 
                    :data="item"/>
				</template>
			</div>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Services from '../../mixins/services';
import Provider from './provider'

export default {
	mixins: [Services],
  props: [],
	components: {
		Provider,
	},
	computed: mapState({
		searchResults: state => state.LocationSearch.searchResults,
	}),
	methods: {
	},
	mounted() {
	},
	created() {
	}
}
</script>